// CustomSelectStyles.js
export const customStyles = {
    control: (provided) => ({
        ...provided,
        boxSizing: 'border-box',
        width: '100%',
        border: 'solid 1.5px var(--line)',
        padding: '2px 0 2px 6px',
        borderRadius: '0',
        fontSize: '14px',
        textWrap: 'nowrap',
    }),
};

export const customTheme = (theme) => ({
    ...theme,
    colors: {
        ...theme.colors,
        neutral50: '#4D4948', // プレースホルダの文字色を変更
    },
});
